module.exports = __webpack_public_path__ + "static/media/4.403e2fe1.png";